import StatCard from "../../common/StatCard";
import { formatCurrency } from "../../../utils/formatters";
import {
  TrendingUp,
  CircleDollarSign,
  Building2,
  AlertCircle,
} from "lucide-react";

const FinancialStatCards = ({ data }) => {
  const stats = [
    {
      icon: <TrendingUp size={16} className="text-primary" />,
      label: "Total Gross Revenue",
      value: formatCurrency(data.totalGrossRevenue),
      accent: "bg-primary/10",
    },
    {
      icon: <CircleDollarSign size={16} className="text-amber-400" />,
      label: "Ingroove Fees Collected",
      value: formatCurrency(data.totalFeesCollected),
      accent: "bg-amber-400/10",
    },
    {
      icon: <Building2 size={16} className="text-blue-400" />,
      label: "Total Hub Payouts",
      value: formatCurrency(data.totalHubPayouts),
      accent: "bg-blue-400/10",
    },
    {
      icon: <AlertCircle size={16} className="text-red-400" />,
      label: "Pending Payout Amount",
      value: formatCurrency(data.pendingPayoutAmount),
      sub: "Awaiting approval",
      accent: "bg-red-400/10",
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {stats.map((s) => (
        <StatCard key={s.label} {...s} />
      ))}
    </div>
  );
};

export default FinancialStatCards;
